export enum EQueryKeys {
  AdminDetails = 'admin-details',
  Admins = 'admins',
  AdminsToSelect = 'admins-to-select',
  BusinessLineDetails = 'business-line-details',
  BusinessLineServices = 'business-line-services',
  BusinessLines = 'business-lines',
  BusinessLinesToSelect = 'business-lines-to-select',
  CompanyDetails = 'company-details',
  DocumentDetails = 'document-details',
  GeographicAreasTree = 'geographic-areas-tree',
  InterventionDetails = 'intervention-details',
  InterventionDocuments = 'intervention-documents',
  InterventionNotes = 'intervention-notes',
  InterventionTaskDetails = 'intervention-task-details',
  InterventionTasks = 'intervention-tasks',
  InterventionTimeline = 'intervention-timeline',
  Interventions = 'interventions',
  NoteDetails = 'note-details',
  PartnershipDetails = 'partnership-details',
  Partnerships = 'partnerships',
  ProviderDetails = 'provider-details',
  ProviderNotes = 'provider-notes',
  ProviderWorkers = 'provider-workers',
  Providers = 'providers',
  ProvidersToSelect = 'providers-to-select',
  RequesterDetails = 'requester-details',
  Search = 'search',
  ServiceDetails = 'service-details',
  ServiceRequestDetails = 'service-request-details',
  ServiceRequestDocuments = 'service-request-documents',
  ServiceRequestDocumentsWithInterventions = 'service-request-documents-with-interventions',
  ServiceRequestInterventions = 'service-request-interventions',
  ServiceRequestNotes = 'service-request-notes',
  ServiceRequestTasks = 'service-request-tasks',
  ServiceRequestTimeline = 'service-request-timeline',
  ServiceRequests = 'service-requests',
  ServiceTypesToSelect = 'service-types-to-select',
  ServiceWorkflowsToSelect = 'service-workflows-to-select',
  Services = 'services',
  ServicesToSelect = 'services-to-select',
  SmartEventEmails = 'smart-event-emails',
  SmartEventProviderEmails = 'smart-event-provider-emails',
  SmartEventRequesterEmails = 'smart-event-requester-emails',
  SmartEventTimeline = 'smart-event-timeline',
  SmartMatchInterventions = 'smart-match-interventions',
  TaskDetails = 'task-details',
  Tasks = 'tasks',
  WorkflowsToSelect = 'workflows-to-select',
}
